function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 24,
  width: 144,
  height: 144,
  rx: 16,
  ry: 16,
  fill: "#f4f4f4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 95.86,
  cy: 95.71,
  r: 10,
  fill: "#4a4d4e"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M125.08 43c0 15.53-11.9 33.71-20.54 44.35-2.08 2.53-8.54 10-8.54 10s-29.08-31.69-29.08-54.9c0-16.64 12.25-30.13 29.08-30.13S125.09 26.31 125.08 43zM96 57a15.65 15.65 0 10-15.66-15.6A15.66 15.66 0 0096 57z",
  fill: "#e60100"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M80.39 40.4a6.63 6.63 0 01-.05-1 15.66 15.66 0 0131.32 0c0 .34-.05.67-.05 1a15.64 15.64 0 00-31.22 0zM125.08 42v1c0 15.53-11.9 33.71-20.54 44.35-2.08 2.53-8.54 10-8.54 10S66.92 65.66 66.95 42.43v-1.25C67.56 64.3 96 95.3 96 95.3s6.47-7.44 8.54-10C113 74.87 124.57 57.21 125.08 42z",
  fill: "#bd0000"
});

var SvgLocationHi = function SvgLocationHi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2, /*#__PURE__*/React.createElement("path", {
    d: "M168 150v2a16 16 0 01-16 16H40a16 16 0 01-16-16v-2a16 16 0 0016 16h112a16 16 0 0016-16z",
    fill: "#e6e6e6",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.47 28.66l-16.86 31.81 31.8 16.86L168 49.82v8.54l-11.05 20.85L168 85.07v4.52l-12.93-6.84-15.39 29 28.32 15v17l-12.49 23.85a15.86 15.86 0 01-3.51.4h-1.23l15.06-28.76-30-15.93-15.53 29.28L149.07 168h-8.54l-22.13-11.85L112 168h-9l8.32-15.58-30-15.93-15.93 30L68 168H51l1.92-3.6L24 149.07v-11.25L37.14 113 24 106v-4.53l15 8 15.5-29.31-30-15.93-.5 1v-14.8l2.59 1.38L41.5 24H53l24.43 13 7.07-13.29 2.56-.71L79 38.21l32 16.64L127.5 24H141l-.66 1.13L168 39.79v4.53zM79.13 42.45l-15.39 29 30 15.93 15.39-29zm-19 27.16l15.39-29-30-15.93-15.39 29zm-17.54 41.75l30 15.93L88.12 98l-30-15.92zm28.18 19.5l-30-15.93-15.93 30 30 15.93zm58-11.28l-30-15.93-15.49 29.28 30 15.93zM119.73 64l-15.39 29 31.86 16.86 15.39-29z",
    fill: "#e6e6e6",
    style: {
      isolation: "isolate"
    }
  }), _ref3, _ref4, _ref5);
};

export default SvgLocationHi;